<script setup lang="ts">
useSeoMeta({
  title: 'Cantook Access',
  ogTitle: 'Cantook Access',
  description: 'Your accessible EPUBs in just a few clicks',
  ogDescription: 'Your accessible EPUBs in just a few clicks',
});

definePageMeta({
  layout: 'pages',
});

const lang = useLocalStorage('CONTENT_LANG', 'en');

const { data: dataQueried } = await useAsyncData('pages-index-data', () =>
  queryCollection('introduction').all(),
);
const data = computed(
  () =>
    dataQueried.value?.find(
      (item) => item.title.toLowerCase() === lang.value?.toLowerCase(),
    )?.body,
);
</script>

<template>
  <div v-if="data">
    <IntroductionHero
      :hero="data.hero"
      :themeKeys="{
        buttonBg: 'var(--color-white)',
        buttonFg: 'var(--color-cantook-blue-600)',
        fg: 'var(--ui-text-inverted)',
        bg: 'var(--color-slate-950)',
      }"
      link="/login"
    />
    <ContentVideo
      :video="data.video"
      :themeKeys="{
        buttonBg: 'var(--color-cantook-blue-200)',
        buttonFg: 'var(--color-cantook-blue-900)',
        icon: 'var(--color-cantook-blue-600)',
      }"
    />
    <Features
      :features="data.features"
      :themeKeys="{
        bg: 'var(--color-cantook-blue-600)',
        title: 'var(--ui-text-inverted)',
        featureTitle: 'var(--ui-text-inverted)',
        text: 'var(--ui-text-inverted)',
        border: 'var(--ui-border)',
        ctaBg: 'var(--color-white)',
        ctaFg: 'var(--color-cantook-blue-700)',
        ctaIcon: 'var(--color-cantook-blue-500)',
      }"
      link="/features"
    />
    <ContentTrustedBy
      :trustedBy="data.trustedBy"
      :themeKeys="{
        title: 'var(--ui-text)',
      }"
    />
    <ContentQuote
      v-if="false"
      :quote="data.quote"
      :themeKeys="{
        text: 'var(--ui-text-muted)',
        byWho: 'var(--ui-text-muted)'
      }"
    />
    <ContentCTA
      :cta="data.cta"
      :themeKeys="{
        bg: 'var(--color-slate-950)',
        fg: 'var(--ui-text-inverted)',
        iconBg: 'var(--color-cantook-blue-500)',
        cta1Fg: 'var(--ui-text)',
        cta1Bg: 'var(--color-white)',
        cta2Fg: 'var(--color-cantook-blue-600)',
        cta2Bg: 'var(--color-white)',
      }"
      :links="{
        pricing: '/pricing',
        signup: '/login',
      }"
    />
  </div>
</template>
